import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';

export class NotificationMethodCheckbox extends React.Component {
  handleInputChange = (event) => {
    this.props.onChange(event.target.name, event.target.checked);
  }

  render = () => (
    <Form.Check>
      <label className="form-check-label">
        <input className="form-check-input" type="checkbox" value="option1"
          aria-label={this.props.ariaCheckboxLabel}
          checked={this.props.isChecked}
          onChange={this.handleInputChange}
          name={this.props.name}
          disabled={this.props.isReadOnly !== undefined && this.props.isReadOnly}
        />
        &nbsp;{this.props.checkboxLabel}
      </label>
    </Form.Check>
  )
}

NotificationMethodCheckbox.propTypes = {
  ariaCheckboxLabel: PropTypes.string.isRequired,
  checkboxLabel: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
};
